// $(document).ready(function() {
//     console.log("document ready");
//     $(document).on('click', '.main-menu .site-nav .item a[href^="#"]', function (e) {
//         e.preventDefault();
//
//         $('html, body').animate(
//             { scrollTop: $($(this).attr('href')).offset().top - 110 },
//             600
//         );
//     })
// });

// $(document).ready(function() {
//     $(document).on('click', '.main-menu .site-nav .item a[href*=\'#\']:not([href=\'#\'])', function(e) {
//         var hash = this.hash;
//         console.log("hash: " + hash);
//         var section = $(hash);
//         console.log("section: " + section);
//
//         if($(hash).length > 0){
//             e.preventDefault();
//
//             if (hash) {
//                 $('html, body').animate({
//                     scrollTop: section.offset().top
//                 }, 1000, 'swing', function(){
//                     history.replaceState({}, "", hash);
//                 });
//             }
//         }
//     });
// });

$(document).ready(function() {
    $('#sidebar-svg-dots>ul>li>a.sidebar-link[href=\"#\"]').addClass("active");

    $(document).on('click', '.main-menu .site-nav .item a[href*=\'#\']:not([href=\'#\'])', function(e) {
        $("html").removeClass("translate-overlay");
        $(".icon-nav.close-menu-mb").removeClass("menu-open");

        var hash = this.hash;
        var section = $(hash);

        $("#sidebar-svg-dots>ul>li>a.sidebar-link").removeClass("active");
        $('#sidebar-svg-dots>ul>li>a.sidebar-link').each(function() {
            if ( hash === this.hash ) {
                $(this).addClass("active");
            }
        });

        if($(hash).length > 0){
            e.preventDefault();

            if (hash) {
                $('html, body').animate({
                    scrollTop: section.offset().top - 110
                }, 600, 'swing');
            }
        } else {
            $('html').css("scroll-behavior", "smooth");
        }
    });

    $(document).on('click', '#sidebar-svg-dots a[href*=\'#\']:not([href=\'#\'])', function(e) {
        var hash = this.hash;
        var section = $(hash);
        $("#sidebar-svg-dots>ul>li>a.sidebar-link").removeClass("active");
        $(this).addClass("active");

        if($(hash).length > 0){
            e.preventDefault();

            if (hash) {
                $('html, body').animate({
                    scrollTop: section.offset().top - 110
                }, 600, 'swing');
            }
        } else {
            $('html').css("scroll-behavior", "smooth");
        }
    });

    $(document).on('click', '#sidebar-svg-dots a[href="#"]', function(e) {
        $("#sidebar-svg-dots>ul>li>a.sidebar-link").removeClass("active");
        $(this).addClass("active");

        e.preventDefault();

        $('html, body').animate({
            scrollTop: 0
        }, 600, 'swing');
    });
});
